import React, { Component } from 'react';
import head from 'lodash/head';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import './DropZone.scss';
import If from '../../../../helpers/if';
import Message from '../../../../message/Message';

class DropZone extends Component {
    state = {
        showErrorMessage: false
    };

    onDrop = (accepted, rejected) => {
        const file = head(accepted);
        const reader = new FileReader();

        reader.onerror = () => {
            this.setState({ showErrorMessage: true });
        };
        try {
            reader.readAsBinaryString(file);
        } catch (e) {
            this.setState({ showErrorMessage: true });
        }
        reader.onload = () => {
            try {
                const fileAsBinaryString = reader.result;
                this.props.onLoad(JSON.parse(fileAsBinaryString));
            } catch (e) {
                this.setState({ showErrorMessage: true });
            }
        };
        this.setState({ showErrorMessage: !!rejected.length });
    };

    render() {
        const { showErrorMessage } = this.state;

        return (
            <div className="dropzone-container">
                <If condition={showErrorMessage}>
                    <div className="errorContainer">
                        <Message
                            body="The file type is not recognize. Please use JSON format."
                            heading="A valid JSON file format is expected."
                            iconXL
                            type="error"
                        />
                    </div>
                </If>
                <Dropzone accept="application/json" multiple={false} onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps, open }) => (
                        <div {...getRootProps({ onClick: e => e.preventDefault() })} className="file-dropzone">
                            <input {...getInputProps()} />
                            <div className="spark-message spark-message--lg spark-message--info spark-panel no-border-panel">
                                <div className="spark-panel__content">
                                    <i className="spark-message__icon spark-icon-file-upload spark-icon--md spark-icon--fill message__icon--xl" />
                                    <div className="spark-message__content">
                                        <h4 className="spark-message__heading">
                                            Drag and drop here or click &ldquo;Browse&rdquo; to upload
                                        </h4>
                                        <p>{this.props.dropZoneDescription}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="button-wrapper">
                                <button type="button" className="spark-btn spark-btn--md" onClick={open}>
                                    Browse Files
                                </button>
                            </div>
                        </div>
                    )}
                </Dropzone>
            </div>
        );
    }
}

DropZone.propTypes = {
    onLoad: PropTypes.func.isRequired,
    dropZoneDescription: PropTypes.string.isRequired
};

export default DropZone;



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/drop-zone/DropZone.js